(function() {
    'use strict';

	angular.module('formonlineApp')
		.config(function ($stateProvider) {
        $stateProvider
            .state('main', {
                parent: 'fullwidth',
                url: '/',
                data: {
					authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/main/main.html',
                        controller: 'MainController'
                    }
                }
//				,
//                resolve: {
//                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
//                        $translatePartialLoader.addPart('main');
//                        return $translate.refresh();
//                    }]
//                }
            });
    });

})();
